import api from './api';

export const getNotifications = async () => {
  try {
    const response = await api.get('/users/notifications/');
    return response.data;
  } catch (err) {
    console.error('Error fetching notifications:', err);
    throw new Error(err.response?.data?.message || 'Failed to fetch notifications');
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.patch(`/users/notifications/${notificationId}/`, {
      read: true
    });
    return response.data;
  } catch (err) {
    console.error('Error marking notification as read:', err);
    throw new Error(err.response?.data?.message || 'Failed to mark notification as read');
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    const response = await api.post('/users/notifications/mark-all-read/');
    return response.data;
  } catch (err) {
    console.error('Error marking all notifications as read:', err);
    throw new Error(err.response?.data?.message || 'Failed to mark all notifications as read');
  }
};

// Polling function for real-time updates
export const startNotificationPolling = (callback, interval = 30000) => {
  const pollNotifications = async () => {
    try {
      const notifications = await getNotifications();
      callback(notifications);
    } catch (err) {
      console.error('Error polling notifications:', err);
    }
  };

  // Initial fetch
  pollNotifications();

  // Set up polling interval
  const intervalId = setInterval(pollNotifications, interval);

  // Return cleanup function
  return () => clearInterval(intervalId);
};
